export default "__VITE_ASSET__DZOHDq7T__"